
<template>
  <span>
    <player-name
      v-if="!isTeam"
      :showIdOfPlatform="showIdOfPlatform"
      :player="player"
    />
    <team-name v-if="isTeam" :team="player" />
  </span>
</template>

<script>
import PlayerName from "./PlayerName.vue";
import TeamName from "./TeamName.vue";

export default {
  components: { PlayerName, TeamName },
  name: "PlayerOrTeamName",
  props: {
    player: {
      type: Object,
      required: true,
    },
    showIdOfPlatform: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    isTeam: function () {
      return this.player.type == "team";
    },
  },
  methods: {},
};
</script>
